module.exports = __webpack_public_path__ + "img/lijixiazai.feb332c6.png";